var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinie02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Linie-02__Icn/40px/Linie-02",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Linie-02__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Linie-02__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.2409903,9.93180643 C27.6005715,9.51261694 28.2318898,9.46429487 28.6510793,9.82387604 C29.0380235,10.1557971 29.1089622,10.7192576 28.8347659,11.1336837 L28.7590097,11.2339651 L11.7590097,31.0520803 C11.3994285,31.4712698 10.7681102,31.5195919 10.3489207,31.1600107 C9.96197655,30.8280896 9.89103777,30.2646291 10.1652341,29.8502031 L10.2409903,29.7499217 L27.2409903,9.93180643 Z",
    id: ".._.._src_svg_Icn_40px_Linie-02__Path-11-Copy"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinie02);
export default __webpack_public_path__ + "static/media/Linie-02.3582780e358fd0850c5987b41ede2681.svg";
export { ForwardRef as ReactComponent };